"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginModal = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
const useLogin_1 = require("./useLogin");
const LoginModal = ({ isOpen, onClose, onLogin, message = 'Join your team with an existing account.', }) => {
    const { authForm, setAuthForm, onSubmit, formErrors, isProcessing, authenticated, authError } = (0, useLogin_1.useLogin)();
    React.useEffect(() => {
        if (authenticated) {
            onClose();
            onLogin();
        }
    }, [authenticated]);
    return (React.createElement(snap_ui_1.ModalContainer, { isOpen: isOpen, onClose: onClose, disableOverlayClose: true },
        React.createElement("div", { className: "sui-px-2 sui-pt-4 sui-pb-1 sui-flex-grow" },
            React.createElement("h2", { className: "sui-heading-md sui-mb-3" }, "Sign in to TeamSnap"),
            React.createElement("p", { className: "sui-body-dense sui-mb-3" }, message),
            authError && (React.createElement(snap_ui_1.Banner, { className: "sui-mb-2", sentiment: "negative", caption: React.createElement("span", null,
                    "Sorry, we didn't recognize that email or password. ",
                    React.createElement("br", null),
                    React.createElement("a", { href: `${constants_1.TEAMSNAP_URL}/login/forgot_password`, className: "sui-link sui-ml-1" }, "Forgot your password?")) })),
            React.createElement(snap_ui_1.Input, { label: "Email", required: true, name: "login-email", className: "sui-block sui-mb-2", onChange: (e) => {
                    setAuthForm('email', e.target.value);
                }, placeholder: "", inputProps: {
                    maxLength: 150,
                    inputMode: 'email',
                }, value: authForm.email || '', type: "email", errors: formErrors?.email ? [formErrors.email] : [], autocomplete: "email" }),
            React.createElement(snap_ui_1.Input, { label: "Password", required: true, name: "login-password", className: "sui-block sui-mb-2", onChange: (e) => {
                    setAuthForm('password', e.target.value);
                }, placeholder: "", inputProps: { maxLength: 255 }, value: authForm.password || '', type: "password", errors: formErrors?.password ? [formErrors.password] : undefined, autocomplete: "current-password" })),
        React.createElement("div", null,
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "submit-login-button", className: "sui-mb-2 sui-w-full", variantType: "primary", labelText: "Sign In", onClick: onSubmit, loading: isProcessing }),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "cancel-login-button", className: "sui-mb-2 sui-w-full", variantType: "secondary", labelText: "Cancel", onClick: onClose }))));
};
exports.LoginModal = LoginModal;
